import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Transcript from "../components/transcription";
import createErrorBoundary from "shared/components/wrappers/errorBoundary";
import {
  updateSegment,
  insertSegment,
  deleteSegment,
} from "../actions/transcriptActions";
import {
  updateMissingTranscriptAppearance,
  updateEventLevelAppearance,
  updateSegmentsRemoved,
} from "../actions/localActions";

const mapStateToProps = (state, ownProps) => {
  return {
    currentContractor: state.currentContractor,
    transcription: state.transcription,
    segments: state.segments.segments.filter((segment) => segment != null),
    currentlyClaimedCalls: state.currentlyClaimedCalls,
    missingTranscriptAppearances: state.local.missingTranscriptAppearances,
    eventLevelPopupAppearances: state.local.eventLevelPopupAppearances,
    segmentsRemoved: state.local.segmentsRemoved || null,
  };
};

// Access relevant actions here
const mapDispatchToProps = (dispatch) => ({
  updateSegment: (index, segment) => dispatch(updateSegment(index, segment)),
  insertSegment: (index, segment) => dispatch(insertSegment(index, segment)),
  deleteSegment: (index) => dispatch(deleteSegment(index)),
  updateMissingTranscriptAppearance: (id) =>
    dispatch(updateMissingTranscriptAppearance(id)),
  updateEventLevelAppearance: (id) => dispatch(updateEventLevelAppearance(id)),
  updateSegmentsRemoved: (id) => dispatch(updateSegmentsRemoved(id)),
});

export default createErrorBoundary()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Transcript))
);
